<div class="dialog" fxLayout="column">
    <!-- close button -->
    <div
        class="dialog-header"
        fxLayout="row"
        fxLayoutAlign="space-between end"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
    >
        <h1 fxFlex translate>charger.charger_screenshot</h1>
        <button mat-icon-button (click)="routedDialog.close()" (keydown.enter)="routedDialog.close()" tabindex="-1">
            <mat-icon svgIcon="close"></mat-icon>
        </button>
    </div>

    <div class="dialog-content">
        <div fxLayout="column" class="inner">
            <div class="screenshot" fxLayout="column" fxLayoutAlign="center center">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <div *ngIf="loading" translate>charger.requesting_screenshot</div>

                <a *ngIf="url" [attr.href]="url" target="_blank"><img [attr.src]="url" /></a>
            </div>
            <div>
                {{ 'charger.satellite' | translate }} {{ satId
                }}{{ url ? ' - ' + (date | date: 'dd.MM.yyyy HH:mm:ss') : '' }}
            </div>
        </div>
    </div>
</div>
